export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGIN_RESET = 'USER_LOGIN_RESET'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST'
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS'
export const USER_LOGOUT_FAIL = 'USER_LOGOUT_FAIL'
export const USER_LOGOUT_RESET = 'USER_LOGOUT_RESET'

export const GET_ROLE_REQUEST = 'GET_ROLE_REQUEST'
export const GET_ROLE_SUCCESS = 'GET_ROLE_SUCCESS'
export const GET_ROLE_FAIL = 'GET_ROLE_FAIL'
export const GET_ROLE_RESET = 'GET_ROLE_RESET'

export const ADD_USER_REQUEST = 'ADD_USER_REQUEST'
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS'
export const ADD_USER_FAIL = 'ADD_USER_FAIL'
export const ADD_USER_RESET = 'ADD_USER_RESET'

export const GET_ADMINS_REQUEST = 'GET_ADMINS_REQUEST'
export const GET_ADMINS_SUCCESS = 'GET_ADMINS_SUCCESS'
export const GET_ADMINS_FAIL = 'GET_ADMINS_FAIL'
export const GET_ADMINS_RESET = 'GET_ADMINS_RESET'

export const GET_ADMIN_BY_ID_REQUEST = 'GET_ADMIN_BY_ID_REQUEST'
export const GET_ADMIN_BY_ID_SUCCESS = 'GET_ADMIN_BY_ID_SUCCESS'
export const GET_ADMIN_BY_ID_FAIL = 'GET_ADMIN_BY_ID_FAIL'
export const GET_ADMIN_BY_ID_RESET = 'GET_ADMIN_BY_ID_RESET'

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL'
export const UPDATE_USER_RESET = 'UPDATE_USER_RESET'

export const RESET_DEVICE_ID_REQUEST = 'RESET_DEVICE_ID_REQUEST'
export const RESET_DEVICE_ID_SUCCESS = 'RESET_DEVICE_ID_SUCCESS'
export const RESET_DEVICE_ID_FAIL = 'RESET_DEVICE_ID_FAIL'
export const RESET_DEVICE_ID_RESET = 'RESET_DEVICE_ID_RESET'

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL'
export const RESET_PASSWORD_RESET = 'RESET_PASSWORD_RESET'

export const REMOVE_CUSTOMER_FROM_USER_REQUEST =
  'REMOVE_CUSTOMER_FROM_USER_REQUEST'
export const REMOVE_CUSTOMER_FROM_USER_SUCCESS =
  'REMOVE_CUSTOMER_FROM_USER_SUCCESS'
export const REMOVE_CUSTOMER_FROM_USER_FAIL = 'REMOVE_CUSTOMER_FROM_USER_FAIL'
export const REMOVE_CUSTOMER_FROM_USER_RESET = 'REMOVE_CUSTOMER_FROM_USER_RESET'

export const ADD_CUSTOMER_TO_USER_REQUEST = 'ADD_CUSTOMER_TO_USER_REQUEST'
export const ADD_CUSTOMER_TO_USER_SUCCESS = 'ADD_CUSTOMER_TO_USER_SUCCESS'
export const ADD_CUSTOMER_TO_USER_FAIL = 'ADD_CUSTOMER_TO_USER_FAIL'
export const ADD_CUSTOMER_TO_USER_RESET = 'ADD_CUSTOMER_TO_USER_RESET'

export const FETCH_ATTENDANCE_REQUEST = 'FETCH_ATTENDANCE_REQUEST'
export const FETCH_ATTENDANCE_SUCCESS = 'FETCH_ATTENDANCE_SUCCESS'
export const FETCH_ATTENDANCE_FAIL = 'FETCH_ATTENDANCE_FAIL'
export const FETCH_ATTENDANCE_RESET = 'FETCH_ATTENDANCE_RESET'

export const RESIGN_USER_REQUEST = 'RESIGN_USER_REQUEST'
export const RESIGN_USER_SUCCESS = 'RESIGN_USER_SUCCESS'
export const RESIGN_USER_FAIL = 'RESIGN_USER_FAIL'
export const RESIGN_USER_RESET = 'RESIGN_USER_RESET'

export const FORCE_LOGOUT_USER_REQUEST = 'FORCE_LOGOUT_USER_REQUEST'
export const FORCE_LOGOUT_USER_SUCCESS = 'FORCE_LOGOUT_USER_SUCCESS'
export const FORCE_LOGOUT_USER_FAIL = 'FORCE_LOGOUT_USER_FAIL'
export const FORCE_LOGOUT_USER_RESET = 'FORCE_LOGOUT_USER_RESET'

export const FORCE_LOGOUT_MULTIPLE_REQUEST = 'FORCE_LOGOUT_MULTIPLE_REQUEST'
export const FORCE_LOGOUT_MULTIPLE_SUCCESS = 'FORCE_LOGOUT_MULTIPLE_SUCCESS'
export const FORCE_LOGOUT_MULTIPLE_FAIL = 'FORCE_LOGOUT_MULTIPLE_FAIL'
export const FORCE_LOGOUT_MULTIPLE_RESET = 'FORCE_LOGOUT_MULTIPLE_RESET'

export const DELETE_ADMIN_REQUEST = 'DELETE_ADMIN_REQUEST'
export const DELETE_ADMIN_SUCCESS = 'DELETE_ADMIN_SUCCESS'
export const DELETE_ADMIN_FAIL = 'DELETE_ADMIN_FAIL'
export const DELETE_ADMIN_RESET = 'DELETE_ADMIN_RESET'

export const BULK_DELETE_ADMINS_REQUEST = 'BULK_DELETE_ADMINS_REQUEST'
export const BULK_DELETE_ADMINS_SUCCESS = 'BULK_DELETE_ADMINS_SUCCESS'
export const BULK_DELETE_ADMINS_FAIL = 'BULK_DELETE_ADMINS_FAIL'
export const BULK_DELETE_ADMINS_RESET = 'BULK_DELETE_ADMINS_RESET'
